import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { inOutAnimation } from '../../../animations';
import { CalculatorResult } from '../../../models/analysis/solar-calculator-result';
import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { UserRole } from '../../../models/user/user-role.enum';
import { PowerPlant } from '../model/power-plant';
import { CalculatorService } from '../calculator.service';
import { UnsubscribeOnDestroyAdapter } from '../../../adapters/unsubscibe-on-destroy.adapter';
import { SavePlantResponse } from '../../../models/analysis/save-plant-response';
import { PaymentService } from '../../../../services/payment.service';
import { PaymentType } from '../../../models/payment/payment-type';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'psc-basic-solar-calculation-result',
  templateUrl: './basic-solar-calculation-result.component.html',
  animations: [inOutAnimation({})],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicSolarCalculationResultComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  @Input() calculatorResultWrapper: CalculatorResultWrapper;
  @Input() powerPlant: PowerPlant | undefined;
  @Input() showRecalculate: boolean = true;
  showSaveAndPayPowerPlantDialog: boolean;

  protected readonly UserRole = UserRole;

  constructor(
    private calculatorService: CalculatorService,
    private paymentService: PaymentService,
    private authService: AuthService,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.calculatorService.saveAndPayEvent.subscribe(() => {
      this.showSaveAndPayPowerPlantDialog = true;
    });
  }

  get solarCalculatorResult(): CalculatorResult {
    return this.calculatorResultWrapper.result;
  }

  onSavedPlant(response: SavePlantResponse) {
    window.location.href = this.paymentService.getAnalysisPaymentStripeUrl(PaymentType.HomeAnalysis, response.userId, response.analysisId, this.authService.getUserEmail());
  }

}
